<template>
    <v-container fluid class="users">
        <v-row>
            <v-col>
                <v-expansion-panels v-model="filteringOptionsPanel">
                    <v-expansion-panel>
                        <v-expansion-panel-header><h2 class="title">Search Users</h2></v-expansion-panel-header>
                        <v-expansion-panel-content style="border-top: 0.5px solid #ddd;">
                            <v-row>
                                <v-col cols="12" xs="12" sm="6" md="4" lg="3">
                                    <v-text-field v-model="filters.id" label="User id" prepend-icon="format_list_numbered" persistent-hint class="text-field"></v-text-field>
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="4" lg="3">
                                    <v-text-field v-model="filters.first_name" label="First name" persistent-hint prepend-icon="person" class="text-field"></v-text-field>
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="4" lg="3">
                                    <v-text-field v-model="filters.last_name" label="Last name" persistent-hint prepend-icon="person" class="text-field"></v-text-field>
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="4" lg="3">
                                    <v-text-field
                                        v-model="filters.email"
                                        label="Email"
                                        hint="Filter by email"
                                        persistent-hint
                                        prepend-icon="alternate_email"
                                        class="text-field"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="align-center justify-end text-center">
                                <v-col cols="12" xs="12" sm="6" md="1">
                                    <v-select v-model="filters.limit" :items="limitOptions" label="Limit" persistent-hint></v-select>
                                </v-col>
                                <div class="d-flex justify-md-right justify-center px-3" :class="{ 'w-100': $vuetify.breakpoint.smAndDown }">
                                    <v-btn color="secondary" @click="loadData()"><v-icon left>search</v-icon> Search</v-btn>
                                </div>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-card class="content-card my-4">
                    <v-card-title>
                        <v-text-field
                            @click.native.stop
                            v-model="search"
                            placeholder="Search"
                            prepend-inner-icon="search"
                            single-line
                            hide-details
                            style="width: 15px;"
                            color="primary"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="getUsers" :items-per-page="-1" :search="search" class="elevation-1">
                        <template v-slot:item="props">
                            <tr class="user-row" @click="goToUser(props.item)">
                                <td class="text-xs-center">
                                    {{ props.item.id }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.first_name }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.last_name }}
                                </td>
                                <td class="text-xs-left">
                                    <strong>{{ props.item.email }}</strong>
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.created_at }}
                                </td>
                                <td class="text-center px-0">
                                    <v-icon
                                        disabled
                                        small
                                        class="px-1"
                                        @click="
                                            $router.push({
                                                name: 'business.edit',
                                                params: { id: props.item.id },
                                            });
                                            $event.stopImmediatePropagation();
                                        "
                                        >edit</v-icon
                                    >
                                    <v-icon
                                        disabled
                                        small
                                        class="px-1"
                                        @click.stop="
                                            openDeleteDialog(props.item);
                                            $event.stopImmediatePropagation();
                                        "
                                        >delete</v-icon
                                    >
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as R from 'ramda';
import { mapGetters, mapMutations } from 'vuex';
// import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';
import { SET_USERS } from '@/store/modules/users/mutation-types';
import { UsersApi } from '@/api';

export default {
    name: 'Users',
    data: () => ({
        filteringOptionsPanel: 1,
        search: '',
        filters: {
            id: null,
            first_name: null,
            last_name: null,
            email: null,
            limit: 100,
        },
        limitOptions: [100, 250, 500, 1000],
        headers: [
            {
                text: 'Id',
                align: 'left',
                sortable: true,
                value: 'id',
                width: '10%',
            },
            {
                text: 'First name',
                align: 'left',
                sortable: true,
                value: 'first_name',
                width: '20%',
            },
            {
                text: 'Last name',
                align: 'left',
                sortable: true,
                value: 'last_name',
                width: '20%',
            },
            {
                text: 'Email',
                align: 'left',
                sortable: true,
                value: 'email',
                width: '20%',
            },
            {
                text: 'Joined at',
                align: 'left',
                sortable: true,
                value: 'created_at',
                width: '20%',
            },
            {
                text: 'Actions',
                value: '',
                align: 'center',
                sortable: false,
                width: '10%',
            },
        ],
        deleteDialog: false,
        itemToDelete: null,
    }),
    computed: {
        ...mapGetters('Users', {
            getRoles: 'getRoles',
            getUsers: 'getUsers',
        }),
    },
    methods: {
        ...mapMutations('Users', {
            setUsers: SET_USERS,
        }),
        async loadData() {
            R.forEachObjIndexed((value, key) => {
                if (value === '') {
                    this.filters[key] = null;
                }
            }, this.filters);
            const { data: items } = await UsersApi.all(this.filters);
            this.setUsers(items);
            this.filteringOptionsPanel = 1;
        },
        goToUser(item) {
            this.$router.push({ name: 'users.details', params: { id: item.id } });
        },
    },
};
</script>

<style lang="scss">
.users {
    .content-card {
        .user-row {
            cursor: pointer;
        }
    }

    .text-field {
        margin: 5px;
    }
}
</style>
